import { explore } from "../../../../service/API";
import store from "../../../store/store";

// TOOLS
const pathInfo = require("path");
export class ProjectSaver {
  constructor(controllerProject, userInfo) {
    this.controllerProject = controllerProject;
    this.path = store.state.config.dirs.root + "temp/" + userInfo.socId + "/projectBeingSaved/";
  }

  createFileList() {
    return new Promise((resolve) => {
      const allElements = Object.keys(this.controllerProject.elements);
      const fileList = [];

      allElements.forEach((element) => {
        const media = this.controllerProject.elements[element].save();

        if (media) {
          media.forEach((file) => {
            // Remove timestamps from mediapath to save correctly
            const mediapath = file.split("?t=")[0];

            if (!fileList.includes(mediapath)) {
              fileList.push(mediapath);
            }
          });
        }
      });

      return resolve(fileList);
    });
  }

  save(savePath) {
    return new Promise((resolve, reject) => {
      // Show wait progress bar on start
      store.dispatch("loadStarted").project;

      // Get project name
      const name = pathInfo.basename(savePath, ".zip");
      // Save current creationController
      let json = this.controllerProject.save(name);
      if (typeof json === "string") {
        try {
          json = JSON.parse(json); // Désérialise la chaîne JSON en objet
          //console.info("JSON récupéré :", json);
        } catch (err) {
          console.error("Erreur lors de la conversion JSON :", err);
          return reject("Données JSON invalides reçues de this.controllerProject.save()");
        }
      }

      // Save animations
      json.refreshAnimation = this.controllerProject.saveAnimations();

      // Retrieve all files used on project
      this.createFileList()
        .then((files) => {
          const body = {
            destPath: savePath,
            uid: store.state.user.userId,
            sid: store.state.user.socId,
            files: files,
            project: json,
          };

          // Create project file
          explore
            .post("/io/createproject/", body)
            .then((response) => {
              if (response.status == 200) {
                // On success resolve promise
                resolve();
              } else {
                // Reject on anything else
                reject("create project failed with status : " + response.status);
              }
            })
            .catch((err) => {
              // Reject on anything else
              reject(err);
            });
        })
        .catch((err) => {
          // Reject on anything else
          reject(err);
        })
        .finally(() => {
          // On finish stop progress animation
          store.dispatch("loadFinished").project;
        });
    });
  }
}
